<template>
    <section class="view spacer">
        <vue-headful
            title="Admin View | What goes into an Admin View"
            description="Admin View allows you to see the nature of administrative support in terms of staffing, contracts, and activities. Identify strategies and opportunities to reduce administrative workload and associated costs."
            url="https://www.fedsight.com/admin-view"
        />
        <section class='container-fluid d-flex align-items-center justify-content-center'>
        </section>

        <section class='viewIntro'>
            <div class='container'>
                <h1 class='viewHeader fedsightBlue'>ADMIN VIEW</h1> 
                <p class='viewMainParagraph'>
                    Admin View provides visibility into the nature of administrative support in terms of staffing, contracts, and costs from an organizational, functional, programmatic, and geographic perspective. It provides up-to-date information on the full scope of administrative support into administrative contracts and personnel profile- by role, series, and grade in summary or down to the specific individual. Identify how specific strategies or operations increase workload. Examine administrative support at a point in time, examine trends from several perspectives, and model the impact of potential changes to budget, workload, and many other areas without having to spend weeks and months trying to manually collect, normalize and validate the data. Admin View's standard reports and analytical models support a broad range of reporting requirements and helps analysts rapidly evaluate potential gaps, overlaps, and opportunities to better align resources to support programmatic efforts.
                </p>
            </div>
            
        </section>

        <section class='blogPost'>
            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Key Business Questions:
                </h2>
                <ul>
                    <li>
                        What is the overall composition of your administrative support in terms of human capital, contracts, facilities, IM/IT, costs, and trends over time?
                    </li>
                    <li>
                        What is the extent to which administrative functions are centrally managed and/or funded? Do duplicative functions exist across the organization? Is there duplication embedded within sub organizations and programs?
                    </li>
                    <li>
                        What is the balance between mission focused investments and administrative support? How do you compare to other organizations both within your agency or other agencies/organizations?
                    </li>
                    <li>
                        What are the trends and costs associated with administrative support overall, for each organization and programmatic area?
                    </li>
                    <li>
                        How have you historically budgeted to support administrative or indirect expenses? What has happened during increases or shortfalls in areas such as administrative PC&B or infrastructure?
                    </li>
                    <li>
                        What is the human capital profile for your administrative organizations? Do you have the optimal mix of resources with the right experience and skills? Do certain organizations and programs need attention?
                    </li>
                    <li>
                        What is the management to staff ratio overall? How does that compare to administrative functions? How does your organization compare to others?
                    </li>
                    <li>
                        How have historical human capital decisions impacted your ability to effectively execute administrative functions and what do the historical trends demonstrate?
                    </li>
                    <li>
                        How have you historically used federal resources vs. contractors to execute key functions and is this balance in sync with mission  and cost objectives?
                    </li>
                </ul>
            </div>

            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Who we are
                </h2>
                <p>
                    Fedsight Consulting is an SBA certified HUBZone small business consulting firm focused on helping organizations improve operations and program performance. Our strategic, financial, and operational support services provide insight and perspective on program performance and operational trends.  Fedsight Consulting’s subject matter expertise, methods, and tools enable federal organizations to accomplish objectives, effectively manage resources, and improve program performance.
                </p>
                <p>
                    To learn more about Fedsight Consulting and discuss potential opportunities, email <span class='emailLink' @click='emailUs()'>info@fedsight.com</span>.
                </p>
            </div>
        </section>

        <Footer />
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../../mixins/closeMenu'


export default {
    name: 'admin-view',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/admin-view'}
      ]
    },
    mixins: [closeMenu],
    methods: {
      emailUs(){
          window.location.href = "mailto:info@fedsight.com?subject=I%20would%20like%20to%20learn%20more%20about%20Fedsight&body=Hello,%0D%0A%0D%0APlease%20contact%20me%20to%20discuss%20how%20Fedsight%20can%20assist%20my%20company.%0D%0A%0D%0A";
      }
    },
    mounted() {
        document.dispatchEvent(new Event('page.rendered'));
    }
}
</script>

<style scoped>
.viewIntro{
    padding: 8rem 0rem 2rem;
    max-width: 100rem;
    margin: auto;
    text-align: left;
}
.viewHeader{
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
    /*background-color: #132631;
    color: #fff; */
    width: 100%;
    padding: 2rem 0rem;
}
.blogPost{
    text-align: left;
}
.blogPostContainer{
    max-width: 100rem;
    margin: 3rem auto;
}
.viewHero{
    height: 30rem;
}
.viewHeader{
    color: #fff;
    font-size: 6rem;
}
.emailLink{
    color: #007bff;
    cursor: pointer;
}
.emailLink:hover{
    color: #0056b3;
    text-decoration: underline;
}
h2{
    margin-top: 3rem;
}


/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>